import styled from "styled-components";
import { Input as InputAntd } from 'antd'

export const Input = styled(InputAntd)`
  height: 40px;
  border-radius: 0px;
  color:${props => props.theme.fontColors.textColor};
  &.ant-input{
      font-size: ${props => props.theme.fontSize.primary};
      @media(max-width: 576px){
          font-size: ${props => props.theme.fontSize.secondary} !important;      
      }
  }
`;